import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { WindowMessage } from '../../types/enum';

export const WindowMessagesActions = createActionGroup({
  source: 'WindowMessagesState',
  events: {
    'Initialize App': props<{
      urlParams: UrlParams;
    }>(),
    'Check App Refresh': emptyProps(),
    'On App Refresh': props<{ windowState: string }>(),
    'Toggle Floating Btn': props<{
      pageList: string[];
    }>(),
    'Send Window Message': props<{
      message: WindowMessage;
      messageData?: any;
    }>(),
  },
});
